import Common from '../Common';
import { MobilePlatform } from '../Enums';

const SMSLogin = class extends Common {
	async attempt(number: string, platform?: MobilePlatform) {
		const body = {
			number,
			platform,
		};

		if(!platform) {
			delete body.platform;
		}

		return this.post('/smslogin', body);
	}

	async verify(number: string, code: string, verificationCode: string) {
		return this.post(
			'/smslogin/verify',
			{
				number,
				code,
				verification_code: verificationCode,
			}
		);
	}
}

export default SMSLogin;
